import React from 'react';
import PropTypes from 'prop-types';

class StartupNameGuesser extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    realName: PropTypes.string.isRequired,
    correct: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    newGuess: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = this.newState();
  }

  componentWillReceiveProps(newProps) {
    if (this.props.total !== newProps.total) {
      this.setState(this.newState());
    }
  }

  onRightClick() {
    this.props.newGuess(true);
  }

  onWrongClick() {
    this.props.newGuess(false);
  }

  newState() {
    const correctIdx = Math.round(Math.random());
    return {
      correctIdx,
    };
  }

  nameSection(key, onClick, text, name) {
    return (
      <div key={key}>
        <button onClick={onClick}>
          {text}
        </button>
        &nbsp;&nbsp;{name}
      </div>
    );
  }

  score() {
    const prop = this.props.total > 0 ?
      this.props.correct / this.props.total * 100 :
      0;
    return (
      `Score: ${this.props.correct} / ${this.props.total} = ${prop.toFixed(1)}%`
    );
  }

  render() {
    const text = 'this one is real!';
    const rightSection = this.nameSection(
      'right',
      () => this.onRightClick(),
      text,
      this.props.realName,
    );
    const wrongSection = this.nameSection(
      'wrong',
      () => this.onWrongClick(),
      text,
      this.props.name,
    );
    const items = [undefined, undefined];
    items[this.state.correctIdx] = rightSection;
    items[1 - this.state.correctIdx] = wrongSection;
    return (
      <div>
        {items}
        {this.score()}
      </div>
    );
  }
}

export default StartupNameGuesser;



// WEBPACK FOOTER //
// src/components/StartupNameGuesser/StartupNameGuesser.js